import { BaseConstants } from './baseConstants';

export class Gender extends BaseConstants {
  static readonly male = new Gender('male', '男性', 'Male');
  static readonly female = new Gender('female', '女性', 'Female');

  private constructor(
    public readonly key: string,
    public readonly label: string,
    public readonly labelEn: string,
  ) {
    super();
  }

  /** 表示言語に応じたラベルを返す。 */
  getLabel(lang?: string): string {
    return lang?.startsWith('en') ? this.labelEn : this.label;
  }

  toString() {
    return this.key;
  }

  static getLabelByKey(key: string): string {
    const item = this.getByKey(key);
    return item?.label || key;
  }
}
